import React, { useState, useEffect } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";

import {
  drawerWidth,
  mainLayoutStyles,
  routes,
  showNotification,
} from "../../../../constants";
import Header from "../../../../common/Header";
import Sidebar from "../../../../common/Sidebar";
import {
  AdminsTable,
  FilterSection,
  SearchBar,
} from "../../components/components";
import { useNavigate } from "react-router-dom";
import {
  deleteAdmin,
  getFilterAdminUsers,
  updateAdmin,
  usersSearch,
} from "../../hooks/AdminsHook";
import { useAdminsContext } from "../../../../providers/OrganizationAdmin/AdminsProvider";
import { Toast } from "../../../../common/alert";
import {
  deleteUserAuth,
  disableUserFunction,
  enableUserFunction,
} from "../../../../firebase";
import ConfirmationModal from "../../../../common/ConfirmationModal";
import { useAuth } from "../../../../hooks";
import { getDateRange } from "../../../OrgProf/hook/Organizationhook";
import FilterModalComponent from "../../../../common/FilterModalComponent";

const AdminsContainer = () => {
  const { currentUser, organizationId } = useAuth();
  const { allAdmins, handleGetAllAdmins, setLoading, loading } =
    useAdminsContext();
  const navigate = useNavigate();

  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [statusFilterOptions, setStatusFilterOptions] = useState([]);
  const [roleFilterOptions, setRoleFilterOptions] = useState([]);
  const [dateAddedFilterOptions, setDateAddedFilterOptions] = useState([]);
  const [lastLoginDateFilterOptions, setLastLoginDateFilterOptions] = useState(
    []
  );

  useEffect(() => {
    handleGetAllAdmins();
    // if (allAdmins?.length) {
    // } else {
    //   handleGetAllAdmins();
    // }
  }, []);

  useEffect(() => {
    // setFilteredAdmins([...allAdmins]);
    if (allAdmins) {
      // Filter out inactive admins by default unless there's a filter explicitly including them
      const filteredAdmins = allAdmins.filter(
        (admin) => admin.status !== "inactive"
      );
      setFilteredAdmins(filteredAdmins);
    }
  }, [allAdmins]);

  const [selected, setSelected] = useState([]);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };
  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };
  const handleSearchAdmins = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let adminsSearchTemp = await usersSearch(allAdmins, value);
        console.log("searched:", adminsSearchTemp);
        setFilteredAdmins(adminsSearchTemp);
      } else {
        // setFilteredAdmins(allAdmins);
        const filteredAdmins = allAdmins.filter(
          (admin) => admin.status !== "inactive"
        );
        setFilteredAdmins(filteredAdmins);
      }
    } catch (error) {
      console.log("error searching admin users:", error.message);
    }
  };

  const handleDeleteAdmin = async () => {
    try {
      setLoading(true);
      const selectedUsersDetails = allAdmins
        .filter((user) => selected.includes(user.id))
        .map((userRecord) => userRecord);

      for (const userData of selectedUsersDetails) {
        await deleteUserAuth({ text: userData.userId });
        await deleteAdmin(userData.id);
      }
      // selected.forEach(async (item) => {
      //   await deleteUserAuth({ text: item.userId });
      //   await deleteAdmin(item.id);
      // });
      await handleGetAllAdmins();
      setSelected([]);
      showNotification("Admin deleted successfully.");
      // Toast("success", "Admin Deleted successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error deleting admin:", error.message);
    } finally {
      handleDeleteModalClose();
      setLoading(false);
    }
  };
  const handleUpdateAdminRole = async (role) => {
    try {
      setLoading(true);
      let dataTemp = {
        role,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      const selectedUsersDetails = allAdmins
        .filter((user) => selected.includes(user.id))
        .map((userRecord) => userRecord);

      for (const userData of selectedUsersDetails) {
        if (currentUser?.role === "super") {
          let responseTemp = await updateAdmin(userData.id, dataTemp);
          console.log("update admin response:", responseTemp);
          showNotification("Admin updated successfully.");
        } else {
          if (currentUser?.role === "manager") {
            if (currentUser?.type === "general") {
              showNotification(
                `You don't have the permissions to update ${
                  userData?.firstName + " " + userData?.lastName
                }`
              );
            } else {
              if (
                userData?.role === "standard" ||
                userData?.role === "moderator"
              ) {
                let responseTemp = await updateAdmin(userData.id, dataTemp);
                console.log("update admin response:", responseTemp);
                showNotification("Admin updated successfully.");
              } else {
                showNotification(
                  `You don't have the permissions to update ${
                    userData?.firstName + " " + userData?.lastName
                  }`
                );
              }
            }
          } else
            showNotification(
              `You don't have the permissions to update ${
                userData?.firstName + " " + userData?.lastName
              }`
            );
        }
      }
      await handleGetAllAdmins();
      setSelected([]);
      // selected.forEach(async (item) => {
      //   let responseTemp = await updateAdmin(item, dataTemp);
      //   console.log("update admin response:", responseTemp);
      // });
      // await handleGetAllAdmins();
      // showNotification("Admin role updated successfully.");
      // Toast("success", "admin role updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating admin role", error.message);
    } finally {
      setLoading(false);
    }
  };
  const handleUpdateAdminStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        status,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      const selectedUsersDetails = allAdmins
        .filter((user) => selected.includes(user.id))
        .map((userRecord) => userRecord);

      for (const userData of selectedUsersDetails) {
        if (currentUser?.role === "super") {
          if (status === "inactive") {
            const result = await disableUserFunction({ uid: userData.id });
          }
          if (status === "active") {
            const result = await enableUserFunction({ uid: userData.id });
          }
          let responseTemp = await updateAdmin(userData.id, dataTemp);
          console.log("update admin response:", responseTemp);
          showNotification("Admin updated successfully.");
        } else {
          if (currentUser?.role === "manager") {
            if (currentUser?.type === "general") {
              showNotification(
                `You don't have the permissions to update ${
                  userData?.firstName + " " + userData?.lastName
                }`
              );
            } else {
              if (
                userData?.role === "standard" ||
                userData?.role === "moderator"
              ) {
                if (status === "inactive") {
                  const result = await disableUserFunction({
                    uid: userData.id,
                  });
                }
                if (status === "active") {
                  const result = await enableUserFunction({ uid: userData.id });
                }
                let responseTemp = await updateAdmin(userData.id, dataTemp);
                console.log("update admin response:", responseTemp);
                showNotification("Admin updated successfully.");
              } else {
                showNotification(
                  `You don't have the permissions to update ${
                    userData?.firstName + " " + userData?.lastName
                  }`
                );
              }
            }
          } else
            showNotification(
              `You don't have the permissions to update ${
                userData?.firstName + " " + userData?.lastName
              }`
            );
        }
      }
      await handleGetAllAdmins();
      setSelected([]);

      // selected.forEach(async (item) => {
      //   let responseTemp = await updateAdmin(item, dataTemp);
      //   console.log("update admin response:", responseTemp);
      // });
      // await handleGetAllAdmins();
      // showNotification("Admin status updated successfully.");
      // Toast("success", "admin status updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating admin status", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterAdminUsers = async () => {
    let dateAddedRange;
    let lastLogindateRange;
    if (dateAddedFilterOptions && dateAddedFilterOptions.length > 0) {
      dateAddedRange = getDateRange(dateAddedFilterOptions, "Date Added");
    }
    if (lastLoginDateFilterOptions && lastLoginDateFilterOptions.length > 0) {
      lastLogindateRange = getDateRange(
        lastLoginDateFilterOptions,
        "Last Login"
      );
    }
    setSelected([]);
    if (
      statusFilterOptions.length > 0 ||
      roleFilterOptions.length > 0 ||
      dateAddedFilterOptions.length > 0 ||
      lastLoginDateFilterOptions.length > 0
    ) {
      let temp = await getFilterAdminUsers(
        statusFilterOptions,
        roleFilterOptions,
        // dateAddedFilterOptions,
        // lastLoginDateFilterOptions,
        dateAddedRange,
        lastLogindateRange,
        setLoading,
        handleFilterModalClose,
        organizationId ? organizationId : currentUser.organization
      );
      console.log("filter data:", temp);
      setFilteredAdmins([...temp]);
    }
    if (
      statusFilterOptions.length === 0 &&
      roleFilterOptions.length === 0 &&
      dateAddedFilterOptions.length === 0 &&
      lastLoginDateFilterOptions.length === 0
    ) {
      // setFilteredAdmins([...allAdmins]);
      const filteredAdmins = allAdmins.filter(
        (admin) => admin.status !== "inactive"
      );
      setFilteredAdmins(filteredAdmins);
    }
  };

  const handleDeleteChip = (filterType, filterItem) => {
    if (filterType === "status") {
      setStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "role") {
      setRoleFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "dateAdded") {
      setDateAddedFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "lastLoginDate") {
      setLastLoginDateFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    }
  };

  useEffect(() => {
    handleFilterAdminUsers();
  }, [
    statusFilterOptions,
    roleFilterOptions,
    dateAddedFilterOptions,
    lastLoginDateFilterOptions,
  ]);

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const resetFilter = async () => {
    setStatusFilterOptions([]);
    setDateAddedFilterOptions([]);
    setLastLoginDateFilterOptions([]);
    setRoleFilterOptions([]);
    // setFilteredAdmins(allAdmins);
    const filteredAdmins = allAdmins.filter(
      (admin) => admin.status !== "inactive"
    );
    setFilteredAdmins(filteredAdmins);
    setSelected([]);
    handleFilterModalClose();
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <Header
        mainTitle={"Admin Users"}
        bgColor="#fff"
        buttonText={
          currentUser?.role === "super" || currentUser?.role === "moderator"
            ? "Add Admin"
            : undefined
        }
        handleSubmit={() => navigate(routes.addAdmin)}
      />
      <Sidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            statusFilterOptions={statusFilterOptions}
            roleFilterOptions={roleFilterOptions}
            dateAddedFilterOptions={dateAddedFilterOptions}
            lastLoginDateFilterOptions={lastLoginDateFilterOptions}
            handleDeleteChip={handleDeleteChip}
          />
          <SearchBar
            placeholder={"Search"}
            selected={selected}
            setSelected={setSelected}
            handleSearch={handleSearchAdmins}
            handleDeleteAdmin={handleDeleteModalOpen}
            handleUpdateAdminRole={handleUpdateAdminRole}
            handleUpdateAdminStatus={handleUpdateAdminStatus}
          />

          <AdminsTable
            selected={selected}
            setSelected={setSelected}
            filteredAdmins={filteredAdmins}
          />
        </Grid>
      </Grid>
      <ConfirmationModal
        modalOpen={deleteModal}
        handleClose={handleDeleteModalClose}
        handleClick={handleDeleteAdmin}
        loading={loading}
        title={"Are you sure to delete the selected Admin(s)?"}
      />
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterAdminUsers}
        data={[
          {
            mainOptions: dateAddedFilterOptions,
            setMainOptions: setDateAddedFilterOptions,
            type: "date",
            title: "Date Added",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
          {
            mainOptions: lastLoginDateFilterOptions,
            setMainOptions: setLastLoginDateFilterOptions,
            type: "date",
            title: "Last Login",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
          {
            mainOptions: statusFilterOptions,
            setMainOptions: setStatusFilterOptions,
            type: "text",
            title: "Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "active", selected: false },
              { label: "inactive", selected: false },
              { label: "invited", selected: false },
            ],
          },
          {
            mainOptions: roleFilterOptions,
            setMainOptions: setRoleFilterOptions,
            type: "text",
            title: "Role",
            currentOptions: [
              { label: "All", selected: true },
              { label: "super", selected: false },
              { label: "manager", selected: false },
              { label: "standard", selected: false },
              { label: "moderator", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default AdminsContainer;
